// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bbezmazrvrgukvapimgv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJiZXptYXpydnJndWt2YXBpbWd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTczNTIyNTQsImV4cCI6MjA3MjkyODI1NH0.J_8ZEalIqt_velbp9bojstrDVPdGaG2_YtUzyWsbFM8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});